import React, { useEffect, useState } from "react";
import { fetchGroups, deleteGroup, fetchGroupById, fetchWordsByGroup, deleteWord } from "./adminSimilarWordsService";
import WordGroupForm from "./WordGroupForm";
import WordForm from "./WordForm";
import "../../blog/tongueTwister.css";

const AdminSimilarWordsPage = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showGroupForm, setShowGroupForm] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);

  const [selectedGroup, setSelectedGroup] = useState(null);
  const [words, setWords] = useState([]);
  const [wordsLoading, setWordsLoading] = useState(false);
  const [showWordForm, setShowWordForm] = useState(false);
  const [editingWord, setEditingWord] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => { loadGroups(); }, [search]);

  const loadGroups = async () => {
    console.log("[AdminSimilarWordsPage] Loading groups");
    setLoading(true);
    const res = await fetchGroups({ search: search || undefined });
    if (res.status === 200) {
      const list = Array.isArray(res.data) ? res.data : res.data?.data || [];
      console.log("[AdminSimilarWordsPage] Groups loaded:", list.length);
      setGroups(list);
    } else { console.error("[AdminSimilarWordsPage] Groups load failed:", res.status); }
    setLoading(false);
  };

  const handleDeleteGroup = async (id, wordCount) => {
    if (wordCount > 0) { alert("Delete all words in this group first."); return; }
    if (!window.confirm("Delete this word group?")) return;
    console.log("[AdminSimilarWordsPage] Deleting group id:", id);
    const res = await deleteGroup(id);
    if (res.status === 200 || res.status === 204) { loadGroups(); if (selectedGroup?.id === id) setSelectedGroup(null); }
    else alert(res.message);
  };

  const openGroupDetail = async (group) => {
    console.log("[AdminSimilarWordsPage] Opening group detail:", group.id, group.title);
    setWordsLoading(true);
    const res = await fetchGroupById(group.id);
    if (res.status === 200 && res.data) {
      setSelectedGroup(res.data);
      if (res.data.words) { setWords(res.data.words); setWordsLoading(false); return; }
    }
    const wRes = await fetchWordsByGroup(group.id);
    if (wRes.status === 200) setWords(Array.isArray(wRes.data) ? wRes.data : wRes.data?.data || []);
    setWordsLoading(false);
  };

  const reloadWords = async () => {
    if (!selectedGroup) return;
    console.log("[AdminSimilarWordsPage] Reloading words for group:", selectedGroup.id);
    const wRes = await fetchWordsByGroup(selectedGroup.id);
    if (wRes.status === 200) setWords(Array.isArray(wRes.data) ? wRes.data : wRes.data?.data || []);
    loadGroups();
  };

  const handleDeleteWord = async (id) => {
    if (!window.confirm("Delete this word?")) return;
    console.log("[AdminSimilarWordsPage] Deleting word id:", id);
    const res = await deleteWord(id);
    if (res.status === 200 || res.status === 204) reloadWords();
    else alert(res.message);
  };

  const onGroupSaved = () => { setShowGroupForm(false); setEditingGroup(null); loadGroups(); };
  const onWordSaved = () => { setShowWordForm(false); setEditingWord(null); reloadWords(); };

  // ===== WORD DETAIL VIEW =====
  if (selectedGroup) return (
    <div className="admin-container">
      <button onClick={() => setSelectedGroup(null)} style={{ marginBottom: 16, background: "none", border: "none", color: "#019095", cursor: "pointer", fontWeight: 600 }}>← Back to Groups</button>
      <div className="admin-header">
        <h2>{selectedGroup.title}</h2>
        <button onClick={() => { setEditingWord(null); setShowWordForm(true); }}>+ Add Word</button>
      </div>
      {selectedGroup.youtubeVideoLink && (
        <p style={{ color: "#888", fontSize: 13, marginBottom: 20 }}>
          Video: <a href={selectedGroup.youtubeVideoLink} target="_blank" rel="noreferrer" style={{ color: "#019095" }}>{selectedGroup.youtubeVideoLink}</a>
        </p>
      )}

      {showWordForm && <WordForm word={editingWord} wordGroupId={selectedGroup.id} onSaved={onWordSaved} onCancel={() => setShowWordForm(false)} />}

      {wordsLoading ? <p>Loading...</p> : (
        <table className="announcement-table">
          <thead><tr><th>Word</th><th>Pronunciation</th><th>Meaning</th><th>Order</th><th>Active</th><th>Actions</th></tr></thead>
          <tbody>
            {words.length === 0 ? (<tr><td colSpan="6">No words yet</td></tr>) : words.map((w) => (
              <tr key={w.id}>
                <td><strong>{w.word}</strong></td>
                <td style={{ fontSize: 13, color: "#888" }}>{w.pronunciation || "—"}</td>
                <td style={{ fontSize: 13 }}>{w.meaning}</td>
                <td style={{ textAlign: "center" }}>{w.displayOrder}</td>
                <td style={{ textAlign: "center" }}>{w.isActive ? "✅" : "❌"}</td>
                <td>
                  <button onClick={() => { setEditingWord(w); setShowWordForm(true); }}>Edit</button>
                  <button className="delete-btn" onClick={() => handleDeleteWord(w.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );

  // ===== GROUPS LIST VIEW =====
  return (
    <div className="admin-container">
      <div className="admin-header">
        <h2>Similar Words Management</h2>
        <button onClick={() => { setEditingGroup(null); setShowGroupForm(true); }}>+ New Group</button>
      </div>

      {showGroupForm && <WordGroupForm group={editingGroup} onSaved={onGroupSaved} onCancel={() => setShowGroupForm(false)} />}

      <input
        type="text"
        placeholder="Search similar word groups..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {loading ? <p>Loading...</p> : (
        <table className="announcement-table">
          <thead><tr><th>Title</th><th>Words</th><th>Order</th><th>Active</th><th>Actions</th></tr></thead>
          <tbody>
            {groups.length === 0 ? (<tr><td colSpan="5">No word groups found</td></tr>) : groups.map((g) => (
              <tr key={g.id}>
                <td>
                  <span style={{ color: "#019095", cursor: "pointer", fontWeight: 600 }} onClick={() => openGroupDetail(g)}>{g.title}</span>
                  {g.youtubeVideoLink && <div style={{ fontSize: 12, color: "#666", marginTop: 2 }}>🎥 Has video</div>}
                </td>
                <td style={{ textAlign: "center" }}>{g.wordCount || 0}</td>
                <td style={{ textAlign: "center" }}>{g.displayOrder}</td>
                <td style={{ textAlign: "center" }}>{g.isActive ? "✅" : "❌"}</td>
                <td>
                  <button onClick={() => { setEditingGroup(g); setShowGroupForm(true); }}>Edit</button>
                  <button className="delete-btn" onClick={() => handleDeleteGroup(g.id, g.wordCount || 0)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminSimilarWordsPage;
